module.exports = __webpack_public_path__ + "8007c3d55ab05f26330d1c3181236c8b.woff";